import React from 'react';
import Layout from '../../components/UI/Layout/Layout'
 import { AppProvider } from '../../providers/appProvider';
import List from '../../components/Entity/Shipper/List/List';

const ShippersPage = () => {
  return <Layout fullwidth={0}>
   
      <List></List>
  
  </Layout>;
}

export default ShippersPage;
